import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CollaborationSchoolComponent } from './collaboration-school/collaboration-school.component';
import { CollaboationSchoolGroupComponent } from './collaboation-school-group/collaboation-school-group.component';
import { CollaborationSchoolViewTutorialComponent } from './collaboration-school-view-tutorial/collaboration-school-view-tutorial.component';


const routes: Routes = [
  { path: '', component: CollaborationSchoolComponent},
  { path: ':groupId', component: CollaboationSchoolGroupComponent},
  { path: ':groupId/:tutorialId', component: CollaborationSchoolViewTutorialComponent},
];  

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CollaborationSchoolRoutingModule { } 

